// extracted by mini-css-extract-plugin
export default {"wrapper":"TextFields_wrapper__D0KQG","input":"TextFields_input__TBuvi","input__label":"TextFields_input__label__e02o1"};